// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__3NVEm","balanceDisclaimer":"posDashboard_balanceDisclaimer__1S0wr"};